import React, { useState } from 'react';
import axios from 'axios';
import UserManagement from './Usermanagement';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('create-tutor');
  
  // Tutor creation state
  const [formData, setFormData] = useState({
    title: 'Mr',
    firstName: '',
    lastName: '',
    email: '',
    institution: '',
    qualification: ''
  });

  // Subject creation state
  const [subjectData, setSubjectData] = useState({
    displayName: '',
    category: '',
    gradeLevels: ''
  });

  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubjectChange = (e) => {
    setSubjectData({
      ...subjectData,
      [e.target.name]: e.target.value
    });
  };

  const handleCreateTutor = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem('token');

      const res = await axios.post(
        'https://mykaddle-api.onrender.com/api/admin/create-tutor',
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setMessage(res.data.message);
      setFormData({
        title: 'Mr',
        firstName: '',
        lastName: '',
        email: '',
        institution: '',
        qualification: ''
      });

    } catch (error) {
      console.error(error);
      setMessage(error.response?.data?.message || 'Server error');
    }
  };

  const handleCreateSubject = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem('token');

      const response = await fetch('https://mykaddle-api.onrender.com/api/admin/subjects', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          displayName: subjectData.displayName,
          category: subjectData.category,
          gradeLevels: subjectData.gradeLevels.split(',').map(level => level.trim())
        })
      });

      const data = await response.json();

      if (!response.ok) {
        setMessage(data.message);
        return;
      }

      setMessage('Subject created successfully');
      setSubjectData({
        displayName: '',
        category: '',
        gradeLevels: ''
      });

    } catch (error) {
      console.error(error);
      setMessage('Error creating subject');
    }
  };

  return (
    <div className="admin-page">
      <aside className="admin-sidebar">
        <h2>Admin Panel</h2>
        <ul>
          <li 
            className={activeTab === 'create-tutor' ? 'active' : ''}
            onClick={() => setActiveTab('create-tutor')}
          >
            Create Tutor
          </li>
          <li 
            className={activeTab === 'add-subjects' ? 'active' : ''}
            onClick={() => setActiveTab('add-subjects')}
          >
            Add Subjects
          </li>
          <li 
            className={activeTab === 'manage-users' ? 'active' : ''}
            onClick={() => setActiveTab('manage-users')}
          >
            Manage Users
          </li>
        </ul>
      </aside>

      <main className="admin-content">
        {activeTab === 'create-tutor' && (
          <>
            <h1>Create Tutor</h1>
            <form className="tutor-form" onSubmit={handleCreateTutor}>
              <select name="title" value={formData.title} onChange={handleChange}>
                <option>Mr</option>
                <option>Mrs</option>
                <option>Ms</option>
                <option>Dr</option>
                <option>Prof</option>
              </select>

              <input
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                required
              />

              <input
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                required
              />

              <input
                name="email"
                type="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <input
                name="institution"
                placeholder="Institution"
                value={formData.institution}
                onChange={handleChange}
              />

              <input
                name="qualification"
                placeholder="Qualification"
                value={formData.qualification}
                onChange={handleChange}
              />

              <button type="submit">Create Tutor</button>
            </form>
          </>
        )}

        {activeTab === 'add-subjects' && (
          <>
            <h1>Add Subjects</h1>
            <form className="subject-form" onSubmit={handleCreateSubject}>
              <input
                name="displayName"
                placeholder="Subject Display Name (e.g., Mathematics)"
                value={subjectData.displayName}
                onChange={handleSubjectChange}
                required
              />

              <input
                name="category"
                placeholder="Category (e.g., Science, Languages)"
                value={subjectData.category}
                onChange={handleSubjectChange}
                required
              />

              <input
                name="gradeLevels"
                placeholder="Grade Levels (comma-separated, e.g., 10,11,12)"
                value={subjectData.gradeLevels}
                onChange={handleSubjectChange}
                required
              />

              <button type="submit">Create Subject</button>
            </form>
          </>
        )}

        {activeTab === 'manage-users' && <UserManagement />}

        {message && <p className="admin-message">{message}</p>}
      </main>
    </div>
  );
};

export default AdminDashboard;